 export const aboutUs = {
    en: {
      title: "About Us",
      intro: "Laftah: Gifts Born from the Heart",
      paragraph1:
        "We believe that the most meaningful gifts aren't just things, but expressions of love, gratitude, and joy. They're the whispers of your heart, bottled up and waiting to be shared.",
      paragraph2:
        "At Laftah, we're passionate about helping you give gifts that truly matter. We're not just a store; we're a partner in creating experiences that will be cherished forever.",
      paragraph3:
        "Whether you're crafting a unique surprise for a loved one or seeking a truly unforgettable way to say 'thank you,' Laftah offers a range of options to help you express yourself authentically.",
      closing: "Let us help you give a gift that speaks from your soul.",
    },
    ar: {
      title: "من نحن",
      intro: "لفتة: هديّة من القلب إلى القلب",
      paragraph1:
        "يأتي لفتة كتطبيق مخصص لتقديم المعايدات والهدايا لتجعل يومك ويوم أحبائك مميزاً. يساعدك لفتة في اكتشاف الهدية المثالية التي تعبر عن مشاعرك الحقيقية وتفرح أحباءك",
      paragraph2:
        "أحباءك وذلك ضمن ميزانياتك المخصصة، من خلال مجموعة واسعة من الخيارات، بدءاً من الهدايا الفريدة المصممة يدوياً وحتى تجارب لا تُنسى. كما يمكنك طلب",
        
      closing: "فيديو معايدة شخصي من نجمك المفضل.",
    },
  };

  
   export const videoSlider = {
      en: {
        title1: "Gifts fade, but memories we create",
        title2: "endure.",
        button: "Direct download for Android",
        telegramButton: "Via Telegram for IPhone"
      },
      ar: {
        title1: "نحن لا نبيع الهدايا، نحن نصنع الذكرى والأثر",
        button: "تحميل مباشر لأجهزة Android",
        telegramButton: "عبر تيليجرام لأجهزة IPhone"
      }
    };

 export const servicesVivaa = {
    en: {
      title: "Laftah Services",
      madeYourGift: "Made Your Gift :",
      celebrityVideo: "Celebrity Video",
      message: "Message :",
      description1: "Find the perfect gift that speaks",
      description2: "to the heart. Work with our team",
      description3: "to design a custom gift that",
      description4: "truly reflects your emotions",
      description5: "Surprise your loved one with a",
      description6: "personalized video message",
      description7: "from their favorite star.",
    },
    ar: {
      title: "خدمات لفتة :",
      madeYourGift: "صمم هديتك :",
      celebrityVideo: "اطلب فيديو من ",
      message: "فنان :",
      description1: "اختر الهدية التي تعبر عن مشاعرك",
      description2: "الحقيقية. كما نساعدك تلاقي شي مميز",
      description3: "وجديد، كما تستطيع تصمم",
      description4: "هدية خاصة بك فقط.",
      description5: "لتفرح قلب محبينك أكتر! فاجئهم بفيديو",
      description6: "خاص من النجم يلي بيحبوه.",
    }
  };

  export const gifts = {
    ar: {
      gifts: "الهدايا",
      seeAll: "عرض الكل",
      next: "التالي",
      back: "السابق"
    },
    en: {
      gifts: "Gifts",
      seeAll: "See All",
      next: "Next",
      back: "Back"
    }
  };


  export const review = {
    en: {
      reviews: "Customer Reviews",
      seeAll: "See All",
      next: "Next",
      back: "Back",
    },
    ar: {
      reviews: "المراجعات",
      seeAll: "عرض الكل",
      next: "التالي",
      back: "السابق",
    },
  };

  
 export const contactUs = {
    ar: {
      contactUs: "اتصل بنا",
      contactInfo: "معلومات الاتصال",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      workingHours: "ساعات العمل",
      address: "العنوان",
      yourMessage: "رسالتك",
      name: "الاسم",
      enterName: "أدخل اسمك",
      enterEmail: "أدخل بريدك الإلكتروني",
      message: "الرسالة",
      writeMessage: "اكتب رسالتك",
      sendMessage: "إرسال الرسالة",
      followLaftah: "تابع لفتة",
      terms: "الشروط والأحكام",
      privacyPolicy: "سياسة الخصوصية"
    },
    en: {
      contactUs: "Contact Us",
      contactInfo: "Contact Information",
      email: "Email",
      phone: "Phone",
      workingHours: "Working Hours",
      address: "Address",
      yourMessage: "Your Message",
      name: "Name",
      enterName: "Enter your name",
      enterEmail: "Enter your email",
      message: "Message",
      writeMessage: "Write your message",
      sendMessage: "Send Message",
      followLaftah: "Follow Laftah",
      terms: "Terms and Conditions",
      privacyPolicy: "Privacy Policy"
    }
  };

  export const header = {
    en: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact Us",
      language: "EN",
    },
    ar: {
      home: "الصفحة الرئيسية",
      about: "من نحن",
      services: "الخدمات",
      contact: "اتصل بنا",
      language: "AR",
    },
  };

  export const viewAllGifts = {
    en: {
      pageTitle: "All Gifts",
      newGifts: "Top Selling",
      oldGifts: "Most Rated",
      backButton: "Back to Home",
    },
    ar: {
      pageTitle: "جميع الهدايا",
      newGifts: "الأكثر مبيعاً",
      oldGifts: "الأكثر شراءً",
      backButton: "الرجوع إلى الصفحة الرئيسية",
    },
  };

  export const viewAllReviews = {
    en: {
      allReviews: "All Reviews",
      backToHome: "Back to Home",
    },
    ar: {
      allReviews: "جميع التقييمات",
      backToHome: "الرجوع إلى الصفحة الرئيسية",
    },
  };
  

  export const terms = {
    en: {
      TermsOfUse: "Welcome to Laftah!",
      TermsOfUse1: "By creating an account on Laftah, you agree to these Terms of Service.",
      TermsOfUse2: "Laftah is designed to simplify gift-giving by helping you select the perfect present.",
      TermsOfUse3: "You can customize and deliver gifts effortlessly through the app.",
      TermsOfUse4: "Additionally, you can request personalized greetings from your favorite artists.",
      AboutUs: "About Us",
      AboutUs1: "Smart Software Services LLC is the developer of the Laftah app.",
      AboutUs2: "We are committed to protecting your privacy and delivering top-notch services.",
      AboutUs3: "We are based in Damascus, Syria. You can contact us via email or phone.",
      AboutUs4: "Email: info@smartsoft-sy.net, Phone: +963 11 4473404.",
      ourGoal: "Our Goal",
      ourGoal1: "We aim to revolutionize gift-giving through the Laftah app.",
      ourGoal2: "The app assists users in selecting gifts with ease.",
      ourGoal3: "You can customize and professionally wrap gifts through the app.",
      ourGoal4: "Our goal is to enhance your experience and provide excellent services.",
      yourAccount: "Your Account",
      yourAccount1: "To use Laftah, you must create an account using your phone number.",
      yourAccount2: "You can delete your account at any time without restrictions.",
      yourAccount3: "If you violate the terms of use, we may suspend or delete your account.",
      serviceAvailability : "",
      serviceAvailability1 : "",
      giftDesign : "",
      giftDesign1 : "",
      celebrityGreetingRequest : "",
      celebrityGreetingRequest1 : "",
      pricingAndPayment : "",
      pricingAndPayment1 : "",
      electronicPaymentTermsOfUse : "",
      electronicPaymentTermsOfUse1 : "",
      ourLocationAndServices : "",
      ourLocationAndServices1 : "",
      complaintsAndSuggestions : "",
      complaintsAndSuggestions1 : ""
    },
    ar: {
      TermsOfUse: "شروط الاستخدام تطبيق لفتة",
      TermsOfUse1: `
      أهلاً بك في تطبيق "لفتة" المخصص لمساعدتك في إيجاد واختيار الهدايا. يهدف تطبيقنا إلى تقديم حلول سريعة وعملية للمساعدة في اختيار الهدايا وتنسيقها وتوصيلها، كما يساعدك على طلب معايدات من فنانك المفضل.
يرجى قراءة هذه الشروط بعناية قبل تفعيل حسابك. إذا كان لديك أي أسئلة تتعلق بهذه الشروط، يرجى الاتصال بنا على الرقم (0118061) قبل تفعيل الحساب، حيث أن هذه الشروط تساعدك في معرفة حقوقك عند استخدامك لخدماتنا وتشكل الاتفاقية القانونية الملزمة بينك وبيننا. 
فعند إنشاء حساب على تطبيق "لفتة" الخاص بك فإنك تؤكد على قبولك لهذه الشروط.
`,
      TermsOfUse2: "",
      TermsOfUse3: "",
      TermsOfUse4: "",
      AboutUs: "معلومات عنا:",
      AboutUs1: `نحن شركة الخدمات البرمجية الذكية محدودة المسؤولية س.ت: 17718 دمشق، والمبرمجة لتطبيق لفتة الخاص باختيار وتنسيق وتوصيل الهدايا ("نحن"، "الخاص بنا"، "لنا" أو "لفتة) ملتزمين بحماية خصوصية بيانات كل مستخدمي تطبيق الهاتف المحمول الخاص بنا لفتة. 
يمكنك التواصل معنا عبر البريد الإلكتروني على العنوان التالي: info@smartsoft-sy.net
أو عبر الهاتف: 963114473404+
`,
      AboutUs2: "",
      AboutUs3: "",
      AboutUs4: "",
      ourGoal: "هدفنا:",
      ourGoal1: `تقديم مفهوم جديد لاختيار وتنسيق الهدايا، ويعمل التطبيق على مساعدة الأفراد في اختيار الهدايا وتنسيقها وتغليفها بشكل احترافي، واختيار توصيلها لمتلقي الهدية أو طالبها، ودفع رسوم الخدمات المقدمة، وتقديم شكاوى واقتراحات لتحسين الخدمة لاحقاً، بالإضافة إلى أي خدمات آخرى يتم إطلاقها لاحقاً.`,
      ourGoal2: "",
      ourGoal3: "",
      ourGoal4: "",
      yourAccount: "حسابك:",
      yourAccount1: `قبل أن تتمكن من طلب هدية أو تصفح التطبيق تحتاج إلى إنشاء حساب عبر تطبيق "لفتة" من خلال رقم هاتفك. ويمكنك إغلاق حسابك في أي وقت عن طريق حذف الحساب
يحق لنا حجب وصولك إلى حسابك أو إغلاقه إذا تم استخدام التطبيق بشكل سيء، على سبيل المثال( تقديم شكاوى غير صحيحة وتم إثبات عدم صحتها أو إساءة معاملة موظفينا أو التشهير بسمعة الشركة أو أي سبب وجيه آخر ).
`,
      yourAccount2: "",
      yourAccount3: "",
      serviceAvailability : "توفر الخدمة:",
      serviceAvailability1 : `نسعى جاهدين لضمان توفر التطبيق على مدار الساعة طوال أيام الأسبوع، ولكن قد تتوقف الخدمة أحياناً لأسباب خارجة عن إرادة الشركة أو لأسباب تحديث وتطوير الخدمة وسنحاول جاهدين أن تكون أوقات توقف الخدمة هي خارج أوقات العمل.
في حال كانت الخدمة غير متوفرة لأي سبب من الأسباب، سوف يتم إعلامك بأن استخدامك للتطبيق غير ممكن حالياً.
`,
      giftDesign : "تصميم هدية:",
      giftDesign1 : `عند الضغط على زر تصميم هدية سيقوم المستخدم بتعبئة استمارة توضح بعض المعلومات المهمة لمعايير الهدية، كنوع المناسبة، جنس متلقي الهدية، الميزانية المالية، اهتمامات المتلقي، تاريخ ووقت ومكان التسليم، طريقة الدفع المناسبة، رقم واتس اب فعال للتواصل.
عند الضغط على زر موافق سيتم التواصل مع المستخدم في أقرب وقت ممكن عبر إحدى وسائل التواصل الاجتماعي لطرح الخيارات الممكنة من الهدايا حسب المعايير التي حددها المستخدم مسبقاً وعند الاتفاق يتم ارسال اشعار للدفع للمباشرة في تنسيق الهدية.
أنت مسؤول عن دفع كامل قيمة الهدية التي تظهر على التطبيق والتي تتضمن ثمن الهدية التي تم الاتفاق معك عليها بالإضافة لأجور تنسيق وتغليف وتوصيل الهدية.
`,
      celebrityGreetingRequest : "طلب معايدة من فنان:",
      celebrityGreetingRequest1 : `عند الضغط على طلب هدية من فنان سيقوم المستخدم بتحديد الفنان المشترك معنا ضمن التطبيق والذي يرغب المستخدم بتلقي معايدة منه، سيتم ملئ استمارة لتحديد المعلومات الهامة للفيديو، كنوع المناسبة، جنس متلقي الهدية، كتابة محتوى المعايدة، تاريخ ووقت التسليم، طريقة الدفع المناسبة، رقم واتس اب فعال للتواصل. بعد ضغط زر متابعة ستتحول للدفع.
أنت مسؤول عن دفع كامل قيمة الهدية التي تظهر على التطبيق.
سيتم معالجة الطلب في أقرب وقت ممكن بعد حفظ المعلومات وتسليم الفيديو في الموعد المحدد وعندها تصبح الملكية الفكرية للفيديو هي للمتلقي.
`,
      pricingAndPayment : "الأسعار والدفع:",
      pricingAndPayment1 : `يعمل تطبيق "لفتة" على التسعير الديناميكي في بعض الوقت، مما يعني أن الأسعار وكلف التوصيل قد تتغير أثناء طلب الهدية، ويمكن أن تتغير الأسعار في أي وقت وفقاً لتقدير الموردين، ولن تؤثر أي تغييرات على الطلبات المثبتة مسبقاً ما لم يكن هناك خطأ واضح في السعر.
يمكنك اختيار من طرق الدفع المتاحة لدينا:
-	نقدي عبر شراء رموز رقمية من نقاط البيع المعتمدة لدينا، ليصل الرمز عبر رسالة نصية لرقم المستخدم ويقوم بإدخالها عبر التطبيق للاستفادة من القيمة الموجودة ضمنها.
-	نقدي عبر الدفع كاش للشركة.
-	دفع إلكتروني باختيار إحدى طرق الدفع المتاحة عبر التطبيق من خلال محفظتك لدى شركات الاتصالات أو عبر محفظتك الإلكترونية لدى إحدى المصارف العاملة في الجمهورية العربية السورية والمشتركة بخدمات الدفع الإلكتروني لدى شركات الوساطة.
نحن مخولون من قبل الفنانين بقبول الدفع نيابة عنهم. إن قمت بدفع ثمن الخدمة لنا فإن ذلك يعفيك ذلك من التزامك من تسديد ثمن الخدمة لهم.
`,
      electronicPaymentTermsOfUse : "شروط استخدام الدفع الإلكتروني:",
      electronicPaymentTermsOfUse1 : `يمكنك استخدام حسابك الإلكتروني لدى المصرف أو شركات الاتصالات المعتمدة من قبلنا وفق القوانين السارية في الجمهورية العربية السورية، وذلك لسداد قيمة الهدية المتفق عليها أو فيديو المعايدة.
لاستخدام الدفع الإلكتروني انت بحاجة لوجود حساب إلكتروني خاص بك لدى المصرف أو لدى شركة الاتصالات الشركاء مع تطبيق "لفتة"، برصيد كافي يمكنك من سداد قيمة فاتورتك عبر حسابك الموجود على التطبيق.
إن الجهة المسؤولة عن الحساب الإلكتروني (المصرف – شركة الاتصالات) هي المسؤولة عن إرسال إشعار التسديد لك.
`,
      ourLocationAndServices : "موقعنا وخدماتنا",
      ourLocationAndServices1 : `نحن نهدف إلى تحديث تطبيقنا وخدماتنا بانتظام، وقد نقوم بتغيير المحتوى في أي وقت. وفي حال دعت الحاجة فقد نعلق الوصول إلى تطبيقنا وخدماتنا أو نغلقها إلى أجل غير مسمى.
قد تكون أي من المواد الموجودة على تطبيقنا أو خدماتنا قديمة في وقت معين، ونحن لسنا ملزمين بتحديث هذه المواد مباشرةً.
`,
      complaintsAndSuggestions : "شكاوى ومقترحات:",
      complaintsAndSuggestions1 : `نحن دائما نعمل على تقديم أفضل الخدمات وتطويرها، ولمساعدتنا يرجى في حال وجود أي شكوى أو مقترحات تتعلق بخدمتنا إعلامنا بها عبر وسائل الاتصال المذكورة أعلاه لنستمر في تقديم الخدمة بأفضل جودة ممكنة.`
    }
  };

  export const privacy = {
    en: {
      privacyPolicy : "Privacy Policy for Laftah App",
      appIntroduction: "About the App:",
      appIntroduction1:
        "Laftah offers users a gift suggestion service, providing options based on factors such as budget, occasion, and recipient's gender and age. Gifts are sourced from local vendors and can be customized and delivered.",
        appIntroduction2:
        'Laftah also offers a "Greeting from an Artist" service, where users can request personalized video messages from celebrities or influencers.',
        appIntroduction3 : "",
        appIntroduction4 : "",
        responsibleEntity: "Responsible:",
        responsibleEntity1:
        "This Privacy Policy explains how Smart Software Services LLC. C.R.: Damascus 17718.",
        responsibleEntity2:
        '("we," "us," or "our"), the developer of the Laftah mobile application ("App"), collects, uses, and shares your personal information. By using the Laftah App, you consent to the practices described in this Privacy Policy.',
        responsibleEntity3: "You can contact us at info@smartsoft-sy.net or +963 11 4473404.",
        responsibleEntity4 : "",
        targetAudience: "Information We Collect:",
        targetAudience1 : `Personal Information: We may collect personal information directly from you, such as:
            Account Information: Name, email address, phone number, date of birth, gender, location.
            Order Information: Order history, delivery address, payment information.
            Usage Data: Information about how you use the App, such as your browsing history and interactions with features.`
          ,
        appFunctionality : "Technical Information:",
        appFunctionality1 : "Device type and operating system.",
        appFunctionality2 : "Mobile network information.",
        appFunctionality3 : "IP address.",
        dataProtection : "How We Use Your Information:",
        dataProtection1 : `• Providing and improving the App: To provide the App's features, personalize your experience, and improve the App's functionality.`,
        dataProtection2 : "• Processing orders: To fulfill your orders, process payments, and manage deliveries.",
        dataProtection3 : "• Communicating with you: To send you order confirmations, updates, and promotional messages.",
        dataProtection4 : "• Customer support: To respond to your inquiries and resolve any issues.",
        dataProtection5 : "• Marketing and advertising: To send you targeted marketing communications and advertisements",
        dataProtection6 : "• Analytics and research: To analyze App usage, improve our services, and conduct market research.",
        userResponsibilities : "Data Sharing",
        userResponsibilities1 : "We may share your information with third-party service providers who assist us in providing the App, such as payment processors, delivery services, and marketing platforms.",
        userResponsibilities2 : "",
        userResponsibilities3 : "",
        informationWeCollect : "",
        informationWeCollect1 : "",
        informationWeCollect2 : "",
        informationWeCollect3 : "",
        rightOfTheOwner : "",
        rightOfTheOwnerSub : "",
        rightOfTheOwnerSub1 : "",
        rightOfTheOwnerSub2 : "",
        duties : "",
        duties1 : "",
        duties2 : "",
        duties3 : "",
        violationMeasures : "",
        violationMeasures1 : "",
        privacyPolicyUpdate : "",
        privacyPolicyUpdate1 : "",
        UseOfYourInformation : "",
        UseOfYourInformation1 : "",
        reasonsForUsingYourInformation : "",
        reasonsForUsingYourInformation1 : "",
        reasonsForUsingYourInformation2 : "",
        reasonsForUsingYourInformation3 : "",
        reasonsForUsingYourInformation4 : "",
        reasonsForUsingYourInformation5 : "",
        reasonsForUsingYourInformation6 : "",
        reasonsForUsingYourInformation7 : "",
        reasonsForUsingYourInformation8 : "",
        reasonsForUsingYourInformation9 : "",
        retentionOfYourInformation : "",
        retentionOfYourInformation1 : "",
        retentionOfYourInformation2 : "",
        retentionOfYourInformation3 : "",
        retentionOfYourInformation4 : "",
        retentionOfYourInformation5 : "",
        disclosureOfYourInformation : "",
        disclosureOfYourInformation1 : "",
        disclosureOfYourInformation2 : "",
        disclosureOfYourInformation3 : "",
        disclosureOfYourInformation4 : "",
        disclosureOfYourInformation5 : "",
        disclosureOfYourInformation6 : "",
        disclosureOfYourInformation7 : "",
        disclosureOfYourInformation8 : "",
        disclosureOfYourInformation9 : "",
        disclosureOfYourInformation10 : "", 
        content : "",
        content1 : "",
        compensation : "",
        compensation1 : "",
        limitationOfLiability : "",
        limitationOfLiability1 : "",
        waiverOfWarranty : "",
        waiverOfWarranty1 : "",
        ThirdPartyDisclaimer : "",
        ThirdPartyDisclaimer1 : ""
    },
  
    ar: {
      privacyPolicy : "",
      appIntroduction : "•	تعريف بالتطبيق ",
      appIntroduction1: `يُقدم لمستخدميه خدمة اقتراح الهدايا المتوفرة لدى موردي الهدايا بالأسواق المحلية، وتغليفها بشكل عصري وجذاب وتوصيلها وذلك بناءً على عدة عوامل أهمها `,
      appIntroduction2: `-	الميزانية المالية لطالب الهدية
-	نوع المناسبة
-	 جنس متلقي الهدية وعمره
كما يقدم تطبيق لفتة خدمة "معايدة من فنان" 
`,
      appIntroduction3: `وهي عبارة عن فيديوهات قصيرة يتم تصويرها من قبل "الفنانين، والمؤثرين بالمجتمع كالرياضيين أو غيرهم" من خلال هواتفهم المحمولة، وذلك بعد ان يصل للفنان والمؤثرين من قبل فريق عمليات لفتة 
`,
      appIntroduction4: `-	اسم متلقي المعايدة (والتي حددها المستخدم طالب الخدمة)
-	ونوع المناسبة (والتي حددها المستخدم طالب الخدمة)
`,
      responsibleEntity: "•	الجهة المسؤولة عن التطبيق",
      responsibleEntity1: "نحن شركة الخدمات البرمجية الذكية محدودة المسؤولية س.ت: 17718دمشق، والمبرمجة لتطبيق لفتة الخاص",
      responsibleEntity2: `باقتراح الهدايا وتغليفها وتوصيلها والمساعدة في تلقي فيديو معايدة من فنان او المؤثرين ("نحن"، "الخاص`,
      responsibleEntity3: `بنا"، "لنا" أو "لفتة) ملتزمين بحماية خصوصية بيانات كل مستخدمي تطبيق الهاتف المحمول الخاص بنا لفتة.`,
      responsibleEntity4: `يمكنك التواصل معنا عبر البريد الإلكتروني على العنوان التالي: info@smartsoft-sy.net
أو عبر الهاتف: 963114473404+
`,
      targetAudience: "•	الفئات المستهدفة",
      targetAudience1: "يحق لأي فرد استخدام تطبيق لفتة.",
      appFunctionality: "•	توصيف عمل التطبيق",
      appFunctionality1: "تطبيق موبايل يعمل على أنظمة تشغيل Android وهو فقط يتطلب الاتصال بالإنترنت للوصول للخدمات الموجودة على المخدم.",
      appFunctionality2: "يرجى قراءة سياسة الخصوصية التالية والتي توضح كيف نستعمل ونحمي معلوماتك. سنكون المتحكمين بالبيانات التي تقدمها لنا.",
      appFunctionality3 : "",
      dataProtection : "•	حقوق المستخدم ومسؤولياته وآليات الحماية والخصوصية لمعلوماته",
      dataProtection1 : "حقوق المستخدم بموجب قانون تنظيم التواصل على الشبكة ومكافحة الجريمة المعلوماتية، قد يكون لديك عدد من الحقوق المتعلقة بالبيانات التي نحتفظ بها عنك. فإذا كنت ترغب ",
      dataProtection2 : "في ممارسة أي من هذه الحقوق، يرجى الاتصال بمسؤول حماية البيانات لدينا باستخدام تفاصيل الاتصال المنشورة أعلاه. ",
      dataProtection3 : "في حال وجود أي شكوى أو مقترحات تتعلق بخدمتنا يرجى إعلامنا بها عبر وسائل الاتصال المذكورة اعلاه لنستمر في تقديم الخدمة بأفضل جودة ممكنة.",
      dataProtection4 : "",
      dataProtection5 : "",
      dataProtection6 : "",
      userResponsibilities : "•	مسؤوليات المستخدم",
      userResponsibilities1 : `1-	إدخال البيانات الصحيحة التي يطلبها منه التطبيق:
-	 الاسم والكنية
-	العمر
-	 رقم هاتفه المحمول 
-	البلد والمدينة التي يقيم بها
-	الاهتمامات التي يهتم بها "الهوايات" 
-	معلومات الدفع الإلكتروني التي تفرضها شركات الدفع المرخصة في الجمهورية العربية السورية
إن الشركة غير مسؤولة عن عدم صحة البيانات في حال تقديم خدمات لا تتناسب مع العمر الصحيح الذي يتم التصريح عنه.
`,
      userResponsibilities2 : `2-	لاستخدام الدفع الإلكتروني، المستخدم بحاجة لوجود حساب فعّال خاص بالمستخدم في مصرف، أو لدى شركات الاتصالات المتعاقدة مع تطبيق لفتة، برصيد كافي في الحساب يُمكنهُ من سداد قيمة الفاتورة النهائية.`,
      userResponsibilities3 : `3-	دفع كامل قيمة الفاتورة التي يتم الاتفاق عليها عبر الواتس اب.`,
      informationWeCollect : "•	المعلومات التي نجمعها عنك",
      informationWeCollect1:`كجزء من التزامنا بخصوصية عملائنا ومستخدمي تطبيق لفتة، فإننا نسعى دوماً لأن نكون واضحين بشأن أنواع المعلومات التي سنجمعها منك. عند استخدام تطبيق لفتة لأول مرة يطلب منك معلومات عن نفسك بما في ذلك الاسم والكنية، رقم الهاتف المحمول، تاريخ الميلاد، الاهتمامات، الجنس، البلد والمدينة.
كما نجمع أيضاً معلومات حول استخدامك للتطبيق مثل: رقم هاتف للتواصل عند تقديم شكوى ومعلومات الدفع الإلكتروني التي تفرض شركات الدفع علينا جمعها بالإضافة لمعلومات الدفع التي تقدمها عند تحويل النقدي.
`,
      informationWeCollect2:`سيتم نقل المعلومات التي نجمعها عن المستخدمين وتخزينها على خوادمنا الموجودة داخل الجمهورية العربية السورية، ونحن حريصون وشفافون للغاية بشأن من تتم مشاركة معلومات المستخدمين معه.
سنتخذ جميع الخطوات اللازمة لضمان التعامل مع بيانات المستخدمين بشكل آمن ووفقاً لسياسة الخصوصية `,
      informationWeCollect3:`هذه وذلك عند نقل المعلومات إلى جهات ثالثة. سنقوم بمعالجة البيانات التي نجمعها عنك فقط إذا كان هناك سبب للقيام بذلك، وإذا كان هذا السبب مسموحاً به بموجب المراسيم والتشريعات المعمول بها ضمن قانون تنظيم التواصل على الشبكة ومكافحة الجريمة المعلوماتية في الجمهورية العربية السورية.`,
      rightOfTheOwner : "•	حقوق الجهة المسؤولة عن التطبيق وواجباتها",
      rightOfTheOwnerSub : "حقوق الجهة المسؤولة عن التطبيق",
      rightOfTheOwnerSub1 : "لنا كل الحق بإنهاء أو تعليق دخول المستخدم أو استخدامه لتطبيق لفتة من دون إشعار مسبق، وذلك عند انتهاكه لهذه الشروط أو القوانين المعمول بها في الجمهورية العربية السورية، أو بسبب أي تصرف قد ترى الشركة أنه مخالف للقوانين أو يلحق الضرر بالشركة أو بالآخرين.",
      rightOfTheOwnerSub2 : "وعند الإنهاء لن يكون بإمكانه الدخول إلى التطبيق، وسوف تستخدم الشركة كل وسيلة متاحة لتطبيق هذا المنع.",
      duties : "الواجبات",
      duties1 : "1.	توفير الخدمة بشكل مستمر وفي حال كانت الخدمة غير متوفرة لأي سبب من الأسباب سوف يتم إعلام المستخدم بأن استخدامه للتطبيق لن يكون ممكناً.",
      duties2 : "2.	ضمان حماية المعلومات التي يتم جمعها عن المستخدمين.",
      duties3 : "3.	متابعة الشكاوى والمقترحات التي يتم تقديمها من قبل المستخدمين.",
      violationMeasures : "•	الإجراءات التي ستتخذها الجهة في حال مخالفة المستخدم لسياسة الاستخدام",
      violationMeasures1 : " يحق لنا حجب وصول المستخدم إلى حسابه أو إغلاقه إذا تم استخدام التطبيق بشكل سيء، على سبيل المثال (تقديم شكاوى غير صحيحة تم إثبات عدم صحتها أو إساءة معاملة موظفينا أو التشهير بسمعة الشركة أو أي سبب وجيه آخر ).",
      privacyPolicyUpdate : "•	تعديل سياسة الخصوصية",
      privacyPolicyUpdate1 : "يحق لنا تعديل شروط وأحكام هذه الاتفاقية، على أن يتم تقديم إشعار بهذا على مواقع الشركة وصفحات التواصل الاجتماعي، وتصبح التعديلات سارية المفعول بمجرد تحريرها. يعتبر تصفحك المعتاد لموقع الشركة وصفحات التواصل الاجتماعي بعد تقديم تلك التعديلات بمثابة تأييد لها، وعليك زيارتهم بانتظام للتحقق من الشروط والأحكام.",
      UseOfYourInformation : "•	استخدام المعلومات الخاصة بك",
      UseOfYourInformation1 : "سنقوم بمعالجة البيانات التي نجمعها عنك فقط إذا كان هناك سبب للقيام بذلك، وإذا كان هذا السبب مسموحاً به بموجب المراسيم والتشريعات المعمول بها ضمن قانون تنظيم التواصل على الشبكة ومكافحة الجريمة المعلوماتية في الجمهورية العربية السورية.",
      reasonsForUsingYourInformation : "•	أسباب استخدام معلوماتك",
      reasonsForUsingYourInformation1 : "1.	لتحسين جودة الخدمة باستمرار بما يتناسب مع توقعات عملائنا، ولمعالجة الأخطاء.",
      reasonsForUsingYourInformation2 : "2.	لتوفير الخدمات التي تم طلبها.",
      reasonsForUsingYourInformation3 : "3.	لنتمكن من تحصيل أجور للخدمات المطلوبة.",
      reasonsForUsingYourInformation4 : "4.	للاتصال بك عند الضرورة فيما يتعلق بخدماتنا المقدمة، كحل المشكلات والشكاوى المقدمة والاطلاع على آرائكم وملاحظاتكم.",
      reasonsForUsingYourInformation5 : "5.	لإعلامكم عن خدماتنا الجديدة وعروضنا الترويجية.",
      reasonsForUsingYourInformation6 : "6.	لتحليل نشاطك واستخدامك لخدماتنا حتى نتمكن من إدارة ودعم وتطوير أعمالنا لأغراض إحصائية ومساعدتنا على منع الاحتيال.",
      reasonsForUsingYourInformation7 : "7.	لتحديد الشروط التعاقدية معك وأي اتفاقية أخرى، ولممارسة أو الدفاع عن المطالبات القانونية وحماية حقوق شركة الخدمات البرمجية الذكية أو موظفي خدمة العملاء في تطبيق ميراث، أو شركات الدفع الإلكتروني أو غيرهم.",
      reasonsForUsingYourInformation8 : "8.	إذا قدمت تعليقات بشأن الخدمات، فقد نستخدم هذه التعليقات في أي مواد تسويقية أو إعلانية، وسوف نقوم بإخفاء اسمك أو أي معلومات شخصية عنك.",
      reasonsForUsingYourInformation9 : "9.	عندما نكون ملزمين باستخدام معلوماتك للامتثال لأي قانون أو مرسوم أو تشريع أو شروط تنظيمية نتعرض قانونياً لها.",
      retentionOfYourInformation : "•	الاحتفاظ بمعلوماتك",
      retentionOfYourInformation1 : `لن نحتفظ بمعلوماتك لفترة أطول مما نعتقد أنه ضروري، حيث سيتم الاحتفاظ بالمعلومات التي نجمعها ما دامت هناك حاجة للوفاء بالأغراض الموضحة في قسم "استخدام المعلومات الخاصة بك" أعلاه بما يتماشى مع مصلحتنا المشروعة أو لفترة تشترطها على وجه التحديد اللوائح أو القوانين المعمول بها، مثل الحفاظ على المعلومات لأغراض التقارير التنظيمية.
عند تحديد فترات الاحتفاظ، سنأخذ في الاعتبار العوامل التالية:
`,
      retentionOfYourInformation2 : "1. التزاماتنا وحقوقنا التعاقدية فيما يتعلق بالمعلومات المعنية.",
      retentionOfYourInformation3 : "2.	الالتزامات القانونية بموجب القوانين المعمول بها بالاحتفاظ بالبيانات لفترة زمنية معينة.",
      retentionOfYourInformation4 : "3.	المنازعات المحتملة.",
      retentionOfYourInformation5 : "4.	الإرشادات الصادرة عن الهيئة الوطنية لخدمات الشبكة والهيئات الحكومية ذات الصلة، بخلاف ذلك، نقوم بمسح معلوماتك بشكل آمن.",
      disclosureOfYourInformation : "•	الكشف عن معلوماتك",
      disclosureOfYourInformation1 : "سيتم نقل المعلومات التي نجمعها عنك وتخزينها على خوادمنا الموجودة داخل الجمهورية العربية السورية، ونحن حريصون وشفافون للغاية بشأن من تتم مشاركة معلوماتك معه. حيث أننا نشارك هذه المعلومات مع الأطراف التالية وعند الحاجة فقط:",
      disclosureOfYourInformation2 : "1.	موظفي قسم خدمة العملاء لحل أي مشكلات قد تواجهك في خدماتنا.",
      disclosureOfYourInformation3 : "2.	شركات الدفع الإلكتروني ويتم تزويدهم فقط بالمعلومات التي يحتاجونها لإتمام عمليات الدفع الإلكتروني.",
      disclosureOfYourInformation4 : "3.	أي طرف ثالث نكون ملزمين وفق القوانين المعمول بها في الجمهورية العربية السورية بالكشف عن معلوماتك قانونياً له.",
      disclosureOfYourInformation5 : `وسنتخذ جميع الخطوات اللازمة لضمان التعامل مع بياناتك بشكل آمن ووفقا لسياسة الخصوصية هذه وذلك عند نقل المعلومات إلى جهات خارجية.
إذا دخل نشاطنا التجاري في مشروع مشترك مع كيان تجاري آخر أو تم شراؤه أو بيعه مع كيان تجاري آخر، فقد يتم الكشف عن معلوماتك أو نقلها إلى الشركة المستهدفة أو شركاء أعمالنا الجدد أو مالكيها أو مستشاريهم.
قد نشارك معلوماتك أيضاً في الحالات الآتية:
`,
      disclosureOfYourInformation6 : `4.	إذا كنا ملزمين بالكشف عن معلوماتك أو مشاركتها من أجل الامتثال (و/ أو عندما نعتقد أننا ملزمون بالامتثال) لأي التزام قانوني أو أمر قضائي أو شرط تنظيمي. يتضمن ذلك تبادل المعلومات مع الشركات الأخرى والمؤسسات الأخرى لأغراض الحماية من الاحتيال والوقاية منه.`,
      disclosureOfYourInformation7 : "5.	من أجل تطبيق شروطنا التعاقدية معك وأي اتفاقية أخرى.",
      disclosureOfYourInformation8 : "6.	لحماية حقوق شركتنا أو موظفينا أو شركات الدفع الإلكتروني أو نقاط البيع أو غيرهم، بما في ذلك منع الاحتيال.",
      disclosureOfYourInformation9 : "7.	ومع الأطراف الثالثة التي نعتبرها ضرورية بشكل معقول من أجل منع الجريمة، على سبيل المثال الضابطة العدلية.",
      disclosureOfYourInformation10 : `8.	تعتبر معلومات الحساب البنكي الخاص بك سرية، حيث ليس لدينا الصلاحية بالحصول على أي معلومات عن حسابك البنكي، ويتم الدفع بطريقة مباشرة وآمنة عبر شركائنا المعتمدين من موقع أو تطبيق البنك أو شركات الاتصالات. وتعتبر عملية الدفع الالكتروني عملية آمنة تخضع بالكامل لمراقبة الجهات المصدرة للدفعة.`,
      content : "•	المحتوى",
      content1 : "نحتفظ بالحق في مراقبة أي محتوى تقوم بإدخاله، إلا أننا غير ملزمين بالحفاظ على المعلومات التي تنتهك شروط هذه الاتفاقية وقوانين الجمهورية العربية السورية. فنحن نحتفظ بالحق من دون الالتزام.",
      compensation : "التعويض:",
      compensation1 : `نمتلك الحق بالمطالبة بالتعويض المادي أو المعنوي نتيجة الإخال بأي شرط من شروط هذه الاتفاقية، لدى أي جهة رسمية أو غير رسمية. ونتيجة لذلك فإنك تتحمل كل التكاليف المالية وغير المالية التي قد تنتج عن الإخلال بأي شرط من شروط هذه الاتفاقية، سواء كانت تأميناً أو تعويضاً أو رسوماً أو أي تكاليف أخرى. كل تسوية لدى أي جهة رسمية أو غير رسمية، بسبب الإخلال بأي شرط من شروط هذه الاتفاقية، لا تعد مقبولة إلا بموافقتنا الصريحة والخطية عليها.`,
      limitationOfLiability : "•	حدود المسؤولية",
      limitationOfLiability1 : `لا نتحمل بأي حال من الأحوال المسؤولية عن الأضرار المباشرة أو غير المباشرة أو الجانبية، التي قد تنشأ نتيجة لاستخدامك أو عدم قدرتك على استخدام خدماتنا أو تطبيق "لفتة".   كما أننا غير مسؤولين عن عدم قيام موردينا بالتزاماتهم القانونية فيما يخص الأمور الضريبية والجمركية وغيرها من الالتزامات القانونية حيث أن حدود مسؤوليتنا تتوقف عند تزويد عملائنا بالخدمات المطلوبة`,
      waiverOfWarranty : "•	التنازل عن الضمان",
      waiverOfWarranty1 : `لا توفر شركة الخدمات البرمجية الذكية أو أي من موظفيها ضمانة عدم تعرض التطبيق أو الخدمة للتوقف أو الخلو من المشكلات أو الحذف أو الأخطاء، كما ال توجد ضمانة بشأن النتيجة التي ستحصل عليها جراء استخدامك للتطبيق.
إن المحتويات والأدوات على التطبيق مقدمة لك على حالها، من دون ضمانات من أي نوع، سواء كانت صريحة أو ضمنية.
`,    
      ThirdPartyDisclaimer : "•	إخلاء المسؤولية من تطبيقات الطرف الثالث",
      ThirdPartyDisclaimer1 : `يخضع استخدام أي تطبيقات تتبع لطرف ثالث لأي شروط يشترطها الطرف الثالث، وليس لأحكام شركة الخدمات البرمجية الذكية.
استخدام تطبيقات الطرف الثالث يقع حصرياً تحت مسؤوليتك ما دامت الشركة لا تتحكم في استخدامات هذه التطبيقات.
الشركة ليست مسؤولة عن أي تطبيقات خاصة بطرف ثالث، وعليك الإقرار بأن مثل هذا التطبيق يمكن تعديله أو حذفه في أي وقت من الأوقات من قبل الناشر الأصلي و /أو مالك الحقوق.
عليك أن تتحمل المسؤولية والمخاطر الناجمة عن استخدام أي من هذه التطبيقات، بما في ذلك المحتويات الموجودة فيه، ونخلي مسؤوليتنا تجاهك وتجاه أي طرف ثالث.
لا نلتزم بفحص أو مسح تطبيقات الطرف الثالث لأي غرض من الأغراض، ولسنا مسؤولين عن دقة واكتمال وملاءمة أو قانونية أي تطبيق خاص بالطرف الثالث.
كون تطبيقات الطرف الثالث متاحة من خلال منصات معروفة أو مشهورة مثل منصة تطبيقات آبل وجوجل أو غيرها فإن ذلك لا يعني الموافقة أو الإذن الانتساب الشركة إلى أي طرف ثالث، ولا يعتبر أيضاً اعتماداً لمثل هذه التطبيقات.
لا نمارس أي سيطرة على التطبيقات والمنتجات والخدمات والبرمجيات ومنصة مستودع تطبيقات آبل وجوجل الخاصة بالطرف الثالث، ولسنا مسؤولين عن أداء هذه المنتجات ولا نعتمدها ولسنا مسؤولين عن أي محتوى أو إعلانات، أو أي مواد متاحة من خلالها، ولسنا مسؤولين بشكل مباشر أو غير مباشر عن أي ضرر أو خسارة لحقت بك عن طريق استخدامك أو اعتمادك على أي خدم ة متوفرة من خلاله.
`
    }
  };